import { z } from 'zod';
import { StudyGroup } from '@prisma/client';
import { bdmTreatmentZodEnum } from '../../enum/bdm-treatment.zod-enum';

export const bdmAssignmentStudyIdSchema = z.string().max(32);

// ETH ships the group as a numeric code
const studyGroupByGruppe: Record<'1' | '2', StudyGroup> = {
  '1': StudyGroup.GROUP_1,
  '2': StudyGroup.GROUP_2,
};
export const bdmAssignmentGruppeSchema = z
  .enum(['1', '2'])
  .transform((value) => studyGroupByGruppe[value]);
export const bdmAssignmentTreatmentSchema = bdmTreatmentZodEnum();
export const bdmAssignmentsImportRow = z.array(z.string());
